import { useGetStationDisplayName } from "@/entities/station";
import { RouteForTitel, TvvStandaardRoute } from "@/entities/tvv";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/shared/components";
import { cn } from "@/shared/utils";

type RouteTitelProps = {
    route: RouteForTitel;
    maxTussenstations?: number;
    className?: string;
};

export function RouteTitel({ route, maxTussenstations = 3, className }: Readonly<RouteTitelProps>) {
    const getStationDisplayName = useGetStationDisplayName();
    const numTussenstationsBasedOnLength = Math.floor(route.stationCodes.join(" - ").length / 15);
    const tussenstations = Math.min(maxTussenstations, numTussenstationsBasedOnLength);
    const { titel, isAfgekort } = TvvStandaardRoute.formatKorteTitel(route, getStationDisplayName, tussenstations);

    if (isAfgekort) {
        return (
            <Tooltip>
                <TooltipTrigger asChild>
                    <span className={cn("text-content-emphasis text-l font-normal", className)}>{titel}</span>
                </TooltipTrigger>
                <TooltipContent>
                    <ul>
                        {route.stationCodes.map((stationCode) => (
                            <li key={stationCode} className="text-s">
                                {getStationDisplayName(stationCode)}
                            </li>
                        ))}
                    </ul>
                </TooltipContent>
            </Tooltip>
        );
    }

    return <span className={cn("text-content-emphasis text-l font-normal", className)}>{titel}</span>;
}
